import { formatAdvancedNumber, formatNumberValue } from './number-formatters';

/**
 * Format blank values (converts '~' to empty string)
 */
export function formatBlankValue(params: any): string {
  const originalValue = params.value;
  return originalValue === '~' ? '' : originalValue;
}

/**
 * Format custom value (returns empty string for pinned rows)
 */
export function formatCustomValue(params: any): any {
  if (params.node?.rowPinned) {
    return '';
  }
  return params.value;
}

/**
 * Format value with expand/collapse icons for tree structures
 */
export function formatNoValue(params: any): any {
  let originalValue = params.value;
  
  if (originalValue != 0 && originalValue != null) {
    const hasData =
      params?.data &&
      (params.data.InvestorID?.length > 1 ||
        params.data.Cash?.length > 1 ||
        params.data.MobileNumber?.length > 1 ||
        params.data.PhoneNumber?.length > 1 ||
        params.data.Email?.length > 1 ||
        params.data.Address1?.length > 1 ||
        params.data.Address2?.length > 1);
    
    if (originalValue.toLocaleString().includes('expand')) {
      originalValue = hasData
        ? originalValue.replace(/expand/g, '') + '<span class="ag-icon ag-icon-tree-open"></span>'
        : originalValue;
    } else {
      originalValue += hasData ? '<span class="ag-icon ag-icon-tree-closed"></span>' : '';
    }
  }
  
  return originalValue;
}

export const valueFormatterAdvanced = (params: any, key: string): string => {
  const rowPinned = params.node?.rowPinned;
  if (key === 'journalNo' && params.data.journalNo === 100) {
    return 'Check:';
  }
  if (rowPinned) {
    return params?.data[key] ? formatAdvancedNumber({ number: params?.data[key] }) : '';
  }
  return formatNumberValue(params, { useDecimalSettings: true });
};

